import { render } from "./services.vue?vue&type=template&id=e1ec9eb8&scoped=true"
import script from "./services.vue?vue&type=script&lang=js"
export * from "./services.vue?vue&type=script&lang=js"

import "./services.vue?vue&type=style&index=0&id=e1ec9eb8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e1ec9eb8"

export default script